import { ReactNode } from "react"
import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"

interface EmptyStateProps {
  icon: ReactNode
  title: string
  description: string
  action?: {
    label: string
    onClick: () => void
  }
  className?: string
}

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn("flex flex-col items-center justify-center p-8 text-center min-h-[300px]", className)}>
      <div className="flex h-20 w-20 items-center justify-center rounded-full bg-primary/10 mb-6">
        <div className="relative z-10 text-primary">
          {icon}
        </div>
      </div>
      <h3 className="text-xl font-bold text-foreground mb-3 tracking-tight">{title}</h3>
      <p className="text-sm text-muted-foreground mb-8 max-w-[280px] leading-relaxed">
        {description}
      </p>
      {action && (
        <Button onClick={action.onClick} className="h-12 px-8 rounded-xl shadow-glow transition-all duration-200 active:scale-[0.97]">
          {action.label}
        </Button>
      )}
    </div>
  )
}
